import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getAvailableStaffAndMachineryCards(options = {}) {
	return _apiRequestWrap(
		ModulesMap.STAFF_AND_MACHINERY_CARDS,
		ModulesConfigMap[ModulesMap.STAFF_AND_MACHINERY_CARDS].GET_AVAILABLE_STAFF_AND_MACHINERY_CARDS,
		options
	)
}

export default {
	getAvailableStaffAndMachineryCards: _getAvailableStaffAndMachineryCards,
}
